import { render, staticRenderFns } from "./mzMaterial.vue?vue&type=template&id=61bf6a0a&scoped=true"
import script from "./mzMaterial.vue?vue&type=script&lang=js"
export * from "./mzMaterial.vue?vue&type=script&lang=js"
import style0 from "./mzMaterial.vue?vue&type=style&index=0&id=61bf6a0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bf6a0a",
  null
  
)

export default component.exports